import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Empty, List, message } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import shallow from 'zustand/shallow';

import { GridList, GridListCardCover } from '../../components/GridList';
import { useAuthStore, useCampaignsStore } from '../../stores';
import { Page } from '../components/Page';
import { TEMPLATES_ROUTE, UPDATE_CAMPAIGN_ROUTE } from '../routes';

import styles from './CampaignsPage.module.less';

const { Meta } = Card;
const { Item } = List;

export function CampaignsPage() {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    campaigns: { campaignsByUserId },
    fetchCampaigns,
  } = useCampaignsStore(({ campaigns, fetchCampaigns }) => ({ campaigns, fetchCampaigns }), shallow);

  const user = useAuthStore(({ user }) => user);

  const [{ loading, error }, fetchCampaignsAction] = useAsyncFn(fetchCampaigns);

  React.useEffect(() => {
    (!campaignsByUserId || (campaignsByUserId && !campaignsByUserId.items)) &&
      user?.attributes?.sub &&
      fetchCampaignsAction(user.attributes.sub);
  }, [fetchCampaignsAction, campaignsByUserId, user]);

  React.useEffect(() => {
    if (error) message.error(error.message);
  }, [error]);

  const handleLoadMore = async () => {
    user?.attributes?.sub && (await fetchCampaignsAction(user.attributes.sub));
  };

  const handleCardClick = (campaignId: string) => () => {
    history.push(generatePath(UPDATE_CAMPAIGN_ROUTE, { campaignId }));
  };

  const handleNewCampaignClick = () => {
    history.push(TEMPLATES_ROUTE);
  };

  return (
    <Page title={t('CAMPAIGNS') as string}>
      {campaignsByUserId && campaignsByUserId.items && campaignsByUserId.items.length === 0 ? (
        <Empty className={styles.empty} description={t('NO_CAMPAIGNS_DESCRIPTION')}>
          <Button type="primary" onClick={handleNewCampaignClick}>
            {t('NO_CAMPAIGNS_CTA')}
          </Button>
        </Empty>
      ) : (
        <GridList
          data={[...((campaignsByUserId && campaignsByUserId.items) || []), null]}
          loading={loading}
          loadMore={!!(campaignsByUserId && campaignsByUserId.nextToken)}
          onLoadMore={handleLoadMore}
          renderItem={(item) => (
            <Item>
              {item ? (
                <Card
                  hoverable
                  cover={<GridListCardCover src={item?.template?.poster} alt={item?.name} />}
                  onClick={handleCardClick(item.id)}
                >
                  <Meta title={item?.name} />
                </Card>
              ) : (
                !loading && (
                  <Card className={styles.plusCard} onClick={handleNewCampaignClick} hoverable>
                    <PlusOutlined />
                  </Card>
                )
              )}
            </Item>
          )}
        />
      )}
    </Page>
  );
}
